import apiClient from '../utilities/apiClient.utility';

const programUrl = `${window.config.CONNECT_URLS.programs}`;

export const getAgencyList = async ({ program_id }) => {
  return await apiClient.get(
    `${programUrl}/${program_id}/dashboard/funding/agency-list`
  );
}

export const createFundingApplication = async ({ program_id, payload }) => {
  return await apiClient.post(
    `${programUrl}/${program_id}/dashboard/funding/application`, payload
  );
}
export const updateFundingApplication = async ({ program_id, id, payload }) => {
  return await apiClient.patch(
    `${programUrl}/${program_id}/dashboard/funding/application/${id}`, payload
  );
}

export const getApplicationStages = async ({ program_id }) => {
  return await apiClient.get(
    `${programUrl}/${program_id}/dashboard/funding/application-stages`
  );
}
export const getApplicationProgressByApplicationId = async ({ program_id,application_id }) => {
  return await apiClient.get(
    `${programUrl}/${program_id}/dashboard/funding/application-progress?funding_application_id=${application_id}`
  );
}

export const updateApplicationProgressByApplicationId = async ({ program_id, application_id, payload }) => {
  return await apiClient.put(
    `${programUrl}/${program_id}/dashboard/funding/application-progress?funding_application_id=${application_id}`, payload
  );
}
